export type TStorageType = 'localStorage' | 'sessionStorage';

export const getStorageItem = (storageType: TStorageType, storageKey: string) => {
  const storage: Storage = globalThis[storageType];
  if (!storageKey) {
    throw new Error(`${storageType} key is missing. Provided value is: "${storageKey}"`);
  }
  try {
    const item = storage.getItem(storageKey);
    if (item) {
      return JSON.parse(item);
    }
    return null;
  } catch (err) {
    throw new Error(`Failed to get item from the ${storageType}: ${err}`, { cause: err });
  }
};

export const setStorageItem = (storageType: TStorageType, storageKey: string, storageValue: unknown) => {
  const storage: Storage = globalThis[storageType];
  try {
    storage.setItem(storageKey, JSON.stringify(storageValue));
  } catch (err) {
    throw new Error(`Failed to set item with key ${storageKey} to the ${storageType}: ${err}`, { cause: err });
  }
};

export const removeStorageItem = (storageType: TStorageType, storageKey: string) => {
  const storage: Storage = globalThis[storageType];
  try {
    storage.removeItem(storageKey);
  } catch (err) {
    throw new Error(`Failed to remove ${storageType} item with key ${storageKey}. ${err}`, { cause: err });
  }
};
